import { useEffect } from "react";
import { importScript } from "../../lib/utils";

export default function CkeditorRenderer({ html, style: parentStyle }) {
  importScript("//cdn.embedly.com/widgets/platform.js");

  useEffect(() => {
    document.querySelectorAll("oembed[url]").forEach((element) => {
      // Create the <a href="..." class="embedly-card"></a> element that Embedly uses
      // to discover the media.
      const anchor = document.createElement("a");

      anchor.setAttribute("href", element.getAttribute("url"));
      anchor.className = "embedly-card";

      element.appendChild(anchor);
    });
  }, []);

  return (
    <div
      className="ck-content"
      style={parentStyle}
      dangerouslySetInnerHTML={{ __html: html }}
    ></div>
  );
}
